import React from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { checkedOutItemShape } from '@bibliocommons/bc-prop-types';

import CheckedOutStatusName from '../CheckedOutStatusName';
import ItemField from '../../shared/ItemField';

import './CheckedOutStatusOverview.scss';

const getDueDate = (item) => {
  if (item.get('dueDate')) {
    return moment(item.get('dueDate'), 'YYYY-MM-DD').format('MMM DD, YYYY');
  }

  return null;
};

const isDownloadable = (item) =>
  item.getIn(['bib', 'policy', 'materialPolicy', 'supportsDownload'], false);

export default function CheckedOutStatusOverview({ item }) {
  return (
    <div className="cp-checked-out-status-overview">
      {item.get('status') !== 'OUT' && <CheckedOutStatusName status={item.get('status')} />}

      <ItemField
        name={<FormattedMessage id="dueDate" />}
        value={getDueDate(item)} />

      {!isDownloadable(item) && <ItemField
        name={<FormattedMessage id="label_times_renewed" />}
        value={item.get('timesRenewed') === 0 ? '0' : item.get('timesRenewed')} />}
    </div>
  );
}

CheckedOutStatusOverview.propTypes = {
  item: checkedOutItemShape
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutStatusOverview/CheckedOutStatusOverview.jsx